<template>
  <form
    autocomplete="off"
    class="order-form gap-0 gap-y-4"
    @submit.prevent="submitForm"
  >
    <div class="col-span-12 mx-auto text-center w-full">
      <h2 :class="modalType === 'status' ? 'border-gray-dark border-b pb-3' : ''">
        Edit Order
      </h2>

      <div
        v-if="modalType === 'status'"
        class="status-input mb-6 text-start"
        :class="{'error': errors && 'status' in errors && errors.status[0]}"
      >
        <label class="text-xl block mb-2">
          Status
        </label>

        <template
          v-for="status in printOrderStatuses"
          :key="status.value"
        >
          <RadioInput
            v-model="formData.status"
            :label="status"
            :value="status"
          />
        </template>
      </div>

      <TextInput
        v-if="modalType === 'trackingUrl'"
        v-model="formData.courierTrackingUrl"
        label="Courier Tracking URL"
        type="url"
        class="mb-8"
        :validation-error="errors && 'courierTrackingUrl' in errors && errors.courierTrackingUrl[0]"
        autofocus
      />

      <div class="flex gap-3 mb-2">
        <AppButton
          :disabled="processing"
          type="button"
          class="btn btn-outline btn-secondary py-2.5 w-full"
          @click="$emit('close')"
        >
          Cancel
        </AppButton>

        <AppButton
          :processing="processing"
          class="btn btn-solid btn-secondary py-2.5 w-full"
        >
          {{ processing ? 'Confirming' : 'Confirm' }}
        </AppButton>
      </div>
    </div>
  </form>
</template>

<script setup>
import { reactive } from 'vue';

import { AppButton } from '@/components/app';
import { RadioInput, TextInput } from '@/components/forms/inputs';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  order: {
    type: Object,
    default: () => {},
  },
  modalType: {
    type: String,
    default: null,
  },
  errors: {
    type: Object,
    default: () => {},
  },
  processing: Boolean,
});

const printOrderStatuses = [ 'Processing', 'Complete'];

const formData = reactive({
  status: props.order?.status || null,
  courierTrackingUrl: props.order?.courierTrackingUrl || null,
});

const submitForm = () => {
  if (!props.processing) {
    emit('confirm', formData);
  }
};

</script>
